/**
 * @generated SignedSource<<5fbb598f8a54aa6495a56912ac21bf6e>>
 * @relayHash 9c112f0a95c7707a76a81ecccd385748
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ccd34a2c80736e32cbd3743483da67d22f4d7f8df5390ff48f5752068921c9a6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneysPageQuery } from './JourneysPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneysPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ccd34a2c80736e32cbd3743483da67d22f4d7f8df5390ff48f5752068921c9a6",
    "metadata": {},
    "name": "JourneysPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
